import { computed, type ComputedRef, type Ref } from "vue";

type MediaContentState = {
	horizVideo?: Record<string, any>[];
	vertVideo?: Record<string, any>[];
	articleList?: Record<string, any>[];
};

export function useTeacherDetailPageMode(
	teacherInfo: Ref<Record<string, any>> | ComputedRef<Record<string, any>>,
	consultService: Ref<Record<string, any>[]> | ComputedRef<Record<string, any>[]>,
	fahuiService: Ref<Record<string, any>[]> | ComputedRef<Record<string, any>[]>,
	mediaContent: Ref<MediaContentState> | ComputedRef<MediaContentState>
) {
	const isAreaTeacher = computed(() => Number(teacherInfo.value?.area_type) === 10);

	const hasMediaContent = computed(
		() =>
			Boolean(mediaContent.value?.horizVideo?.length) ||
			Boolean(mediaContent.value?.vertVideo?.length) ||
			Boolean(mediaContent.value?.articleList?.length)
	);

	return {
		isAreaTeacher,
		hasMediaContent,
	};
}
